import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgEyeSlash = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M5.897 3.787a.875.875 0 1 0-1.295 1.176L6.707 7.28C2.734 9.717 1.026 13.475.95 13.646a.875.875 0 0 0 0 .71c.039.087.965 2.141 3.025 4.2C6.719 21.3 10.185 22.75 14 22.75c1.96.011 3.901-.392 5.695-1.184l2.406 2.647a.873.873 0 0 0 1.448-.21.876.876 0 0 0-.153-.966L5.897 3.787Zm5.177 8.295 4.558 5.014a3.5 3.5 0 0 1-4.558-5.014ZM14 21c-3.367 0-6.308-1.224-8.742-3.637A14.55 14.55 0 0 1 2.734 14c.513-.961 2.15-3.652 5.18-5.4l1.968 2.16a5.25 5.25 0 0 0 6.963 7.656l1.61 1.771A12.25 12.25 0 0 1 14 21Zm.656-10.438a.876.876 0 0 1 .328-1.719 5.267 5.267 0 0 1 4.24 4.664.875.875 0 0 1-.789.952.701.701 0 0 1-.082 0 .876.876 0 0 1-.875-.794 3.509 3.509 0 0 0-2.822-3.103Zm12.39 3.795c-.046.102-1.154 2.556-3.648 4.79a.874.874 0 1 1-1.168-1.304A14.519 14.519 0 0 0 25.271 14a14.564 14.564 0 0 0-2.529-3.366C20.308 8.224 17.367 7 14 7c-.71 0-1.418.057-2.117.172a.875.875 0 1 1-.29-1.726c.796-.132 1.6-.197 2.407-.196 3.815 0 7.281 1.45 10.025 4.195 2.06 2.06 2.986 4.114 3.024 4.2a.874.874 0 0 1 0 .712h-.003Z" />
  </svg>
);
export default SvgEyeSlash;
